import { JobStatusType, ReadJobsRequest } from '@openapi';
import { Job } from '@services/types';
import { getJobsApi } from './configuration';

const jobs = {
  deleteJob: (jobId: Job['id']) => {
    return getJobsApi().deleteJob({ id: jobId });
  },
  deleteAllJobs: () => {
    return getJobsApi().deleteJobs();
  },
  cancelJob: (jobId: Job['id']) => {
    return getJobsApi().updateJobStatus({ id: jobId, body: JobStatusType.Cancelled });
  },
  getJob: (jobId: Job['id']) => {
    return getJobsApi().readJob({ id: jobId });
  },
  getJobInput: (jobId: Job['id']) => {
    return getJobsApi().readJobInput({ id: jobId });
  },
  getJobRejection: (jobId: Job['id']) => {
    return getJobsApi().readJobRejection({ id: jobId });
  },
  getJobReport: (jobId: Job['id']) => {
    return getJobsApi().readJobReport({ id: jobId });
  },
  getJobs: (requestParameters?: ReadJobsRequest) => {
    return getJobsApi().readJobs(requestParameters);
  },
};

export default jobs;
